export const BYTES_IN_KB = 1000;
export const BYTES_IN_MB = BYTES_IN_KB * BYTES_IN_KB;
export const BYTES_IN_GB = BYTES_IN_MB * BYTES_IN_KB;
export const BYTES_IN_TB = BYTES_IN_GB * BYTES_IN_KB;
